import React, { useState } from 'react'
import Icon from '../../../blocks.simple/icon/icon'
import styles from './selectFromFile.jcss'
import translate from '../../../core/translate'
import { RootStateOrAny, useSelector } from 'react-redux'
import { api } from '../../../core/api/ConnectionManager'

export const SelectFromFile = ({ onSelectFromFile, type }: { onSelectFromFile: (file: any) => void; type: string }) => {
    const tokens = useSelector((state: RootStateOrAny) => state.user.tokens)
    const [inProgress, setInProgress] = useState<boolean>(false)

    const getType = () => {
        switch (type) {
            case 'displays':
                return 'digitalSignage'
            default:
                return ''
        }
    }

    const onChange = (e: any) => {
        const formData = new FormData()

        formData.append('file', e.target.files[0])
        formData.append('type', getType())

        if (tokens.accessToken) {
            setInProgress(true)

            e.target.value = ''

            api.post('getSelectionByFile', formData, {
                Authorization: `Bearer ${tokens.accessToken}`,
            }).then((res: any) => {
                setInProgress(false)

                if (!res && !res.body && !res.body.data) return

                const data = res.body.data

                onSelectFromFile({ selected: data.selected, notSelected: data.notSelected })
            })
        }
    }

    return (
        <div className={styles.selectorWrapper}>
            {inProgress ? (
                <div className={styles.inProgress}>{translate('selectFromFileProgress')}</div>
            ) : (
                <>
                    <Icon type="file" default={true} />
                    <label className={styles.selectorText} htmlFor={'upload'}>
                        <span>{translate('selectFromFile')}</span>
                        <input
                            type={'file'}
                            id={'upload'}
                            style={{ display: 'none' }}
                            accept={'.xlsx'}
                            onChange={onChange}
                        />
                    </label>
                </>
            )}
        </div>
    )
}
